// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__1GQj1","label":"style_label__2ROiz"};